class RoundNumber {
  // Round Up To Nearest 10
  roundTo(value: number = 0): number {
    return Math.round(value / 10) * 10
  }
}

export default RoundNumber
